import type { ReactNode } from "react"
import { cn } from "@/shared/lib/cn"

/**
 * Um bloco numerado da ficha.
 *
 * A numeracao nao e enfeite: ela e a mesma da ficha em papel da DIMPET. Quem
 * recebe o pedido confere contra o documento que ja usa, e o candidato que tem
 * a ficha impressa em maos encontra os campos no mesmo lugar.
 *
 * `fieldset` de verdade, com `legend`: e o que faz um leitor de tela anunciar
 * "Dados do estabelecimento" antes dos treze campos que vem em seguida.
 */
export interface FormBlockProps {
  number: number
  title: string
  description?: ReactNode
  children: ReactNode
  className?: string
}

export function FormBlock({ number, title, description, children, className }: FormBlockProps) {
  return (
    <fieldset className={cn("flex flex-col gap-5", className)}>
      {/* `mb` e nao `gap`: um `legend` nao e item flex do proprio fieldset, e o
          `gap-5` acima nao alcanca o espaco entre o titulo e o primeiro campo. */}
      <legend className="w-full mb-5">
        <span className="flex items-center gap-3">
          <span className="shrink-0 w-7 h-7 rounded-lg bg-verde-profundo text-off-white text-xs font-semibold flex items-center justify-center">
            {number}
          </span>
          <span className="text-base font-semibold text-verde-profundo leading-snug">{title}</span>
        </span>

        {description ? (
          <span className="block text-sm text-verde-profundo/50 leading-relaxed mt-2 ml-10">
            {description}
          </span>
        ) : null}
      </legend>

      <div className="flex flex-col gap-5">{children}</div>
    </fieldset>
  )
}
